import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'app-step-progress-step',
  templateUrl: './step.component.html',
  styleUrls: ['./step.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepProgressStepComponent {
  @Input()
  get active(): boolean {
    return this.isActive;
  }
  set active(value: boolean) {
    this.isActive = value;
    this.activeChanged.emit();
  }

  @Output() activeChanged = new EventEmitter();

  @HostBinding('class.step-completed') completed = false;
  @HostBinding('class.next-step-completed') nextCompleted = false;

  private isActive = false;
}
